import { gql } from "@apollo/client";

export const LIST_CLIENT_VAT_ACCOUNTING_CONFIGS = gql`
  query listClientVatAccountingConfigs(
    $filter: ClientVatAccountingConfigFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listClientVatAccountingConfigs(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        editable
        clientVatType {
          id
          code
          name
        }
        productType {
          id
          code
          name
        }
        counterpartCode
      }
    }
  }
`;

export const CREATE_CLIENT_VAT_ACCOUNTING_CONFIG = gql`
  mutation createClientVatAccountingConfig($input: CreateClientVatAccountingConfigInput!) {
    createClientVatAccountingConfig(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_CLIENT_VAT_ACCOUNTING_CONFIG = gql`
  mutation updateClientVatAccountingConfig($input: UpdateClientVatAccountingConfigInput!) {
    updateClientVatAccountingConfig(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const DELETE_CLIENT_VAT_ACCOUNTING_CONFIG = gql`
  mutation deleteClientVatAccountingConfig($id: ID!) {
    deleteClientVatAccountingConfig(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const GET_CLIENT_VAT_ACCOUNTING_CONFIG = gql`
  query getClientVatAccountingConfig($id: ID!) {
    getClientVatAccountingConfig(id: $id) {
      id
      counterpartCode
      clientVatType {
        id
        code
        name
      }
      productType {
        id
        code
        name
      }
      editable
      counterpartCodeData {
        name
        code
      }
    }
  }
`;

export const LIST_PRODUCT_ACCOUNTING_CONFIG = gql`
  query listProductAccountingConfig(
    $filter: ProductAccountingConfigFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listProductAccountingConfig(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        editable
        clientVatType {
          id
          code
          name
        }
        productType {
          id
          code
          name
        }
        vat {
          id
          name
          code
          ratePercentage
        }
        counterpartCode
      }
    }
  }
`;

export const CREATE_PRODUCT_ACCOUNTING_CONFIG = gql`
  mutation createProductAccountingConfig($input: CreateProductAccountingConfigInput!) {
    createProductAccountingConfig(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_PRODUCT_ACCOUNTING_CONFIG = gql`
  mutation updateProductAccountingConfig($input: UpdateProductAccountingConfigInput!) {
    updateProductAccountingConfig(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const DELETE_PRODUCT_ACCOUNTING_CONFIG = gql`
  mutation deleteProductAccountingConfig($id: ID!) {
    deleteProductAccountingConfig(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const GET_PRODUCT_ACCOUNTING_CONFIG = gql`
  query getProductAccountingConfig($id: ID!) {
    getProductAccountingConfig(id: $id) {
      id
      editable
      counterpartCode
      clientVatType {
        id
        code
        name
      }
      productType {
        id
        code
        name
      }
      vat {
        id
        name
        code
        ratePercentage
      }
      counterpartCodeData {
        name
        code
      }
    }
  }
`;
